import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
//import 'core-js/es/object'
import App from 'App'

import { GlobalStateProvider } from 'globalState'
import 'globalStyles'
import './i18n'
import './index.css'
import { handleNetworkChange } from './utils/utils'
import Spinner from './components/Spinner'
import { ToastContainer } from 'react-toast'
import LocaleProvider from 'context/locale.context'

window.addEventListener('load', async () => {
  // console.log('app config', process.env)
  const { client, networkId } = await handleNetworkChange()

  if (networkId !== 43113) {
    console.log = function() {}
    console.warn = function() {}
    console.error = function() {}
  }

  ReactDOM.render(
    <Suspense fallback={<Spinner />}>
      <GlobalStateProvider>
        <LocaleProvider>
          <App initialClient={client} initialNetworkId={networkId} />
          <ToastContainer position="top-right" delay={4000} />
        </LocaleProvider>
      </GlobalStateProvider>
    </Suspense>,
    document.getElementById('root')
  )
})
